import { useState,useEffect } from 'react';
import LeftSidebar from './LeftSidebar';
import Topbar from './Topbar';
import Heading from './Heading';
import ContentFirst from './ContentFirst';
import Footer from './Footer';
import { BASE_URL } from '../Config';
import axios from 'axios';

export default function Dashboard() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
   
    const refetchOrders = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${BASE_URL}/api/orders_details`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const orders = response.data.orders;
            console.log('Fetched orders:', orders);
            setData(orders);

            

            
            setLoading(false);
        } catch (error) {
            console.error('Error fetching orders:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        refetchOrders();
    }, []);

    return (
        <div>
            <div id="page-top">
                <div id="wrapper">
                    <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                            <div className="container-fluid">
                                <Heading />
                                <ContentFirst orders={data} />
                                {/* <ContentChart /> */}
                                {/*<ContentProjects />*/}
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </div>
    );
}
